import React from "react";
import { useTranslation } from "react-i18next";
import { Alert, Box, Button, Dropdown, Text } from "~/components-shared";
import mixpanel from "mixpanel-browser";
import styled from "styled-components";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import toastsActionCreators from "~/store/toasts/actions";
import memberTeamSchema from "~/forms/MemberTeamForm/memberTeamSchema";
import { useDispatch, useSelector } from "react-redux";
import MemberTeamForm from "~/forms/MemberTeamForm";
import membersActionCreators from "~/store/members/actions";
import memberSelectors from "~/store/members/selectors";
import { StatusStateEnum } from "~/types/enums";
const StickyBottomBox = styled(Box)`
  position: sticky;
  bottom: 0;
  background-color: ${_ref => {
  let {
    theme
  } = _ref;
  return theme.colors.background.primary;
}};
  z-index: 1;
`;
const MemberTeamsDropdown = _ref2 => {
  let {
    team,
    isOpen,
    onItemClick
  } = _ref2;
  const {
    t
  } = useTranslation();
  const status = useSelector(memberSelectors.getStatusByTeam(team?.id || "+"));
  const error = useSelector(memberSelectors.getErrorByTeam(team?.id || "+"));
  const filter = useSelector(memberSelectors.getFilter);
  const dispatch = useDispatch();
  const defaultValues = {
    name: team?.name || "",
    memberIds: team?.members.map(member => member.id) || []
  };
  const {
    handleSubmit,
    control,
    reset,
    watch,
    setValue
  } = useForm({
    resolver: yupResolver(memberTeamSchema),
    defaultValues
  });
  const onSubmit = handleSubmit(data => {
    if (team) {
      dispatch(membersActionCreators.updateTeamStarted(team.id, data, _ref3 => {
        let {
          data: newTeam
        } = _ref3;
        if (newTeam) {
          dispatch(toastsActionCreators.pushed({
            severity: "success",
            message: t("MemberTeamsDropdown.teamUpdated", {
              name: newTeam.name
            }),
            timeout: 10000
          }));
          reset(defaultValues);
          onItemClick();
          mixpanel.track(`Member Teams Update – Save`, {
            ...data
          });
        }
      }));
    } else {
      dispatch(membersActionCreators.createTeamStarted(data, _ref4 => {
        let {
          data: newTeam
        } = _ref4;
        if (newTeam) {
          dispatch(toastsActionCreators.pushed({
            severity: "success",
            message: t("MemberTeamsDropdown.teamCreated", {
              name: newTeam.name
            }),
            timeout: 10000
          }));
          reset(defaultValues);
          onItemClick();
          mixpanel.track(`Member Teams Create – Save`, {
            teamId: newTeam.id,
            ...data
          });
        }
      }));
    }
  });
  const handleDelete = () => {
    if (team) {
      dispatch(membersActionCreators.deleteTeamStarted(team.id, _ref5 => {
        let {
          data
        } = _ref5;
        if (data) {
          dispatch(toastsActionCreators.pushed({
            severity: "success",
            message: t("MemberTeamsDropdown.teamDeleted", {
              name: team.name
            }),
            timeout: 10000
          }));
          reset(defaultValues);
          onItemClick();
          dispatch(membersActionCreators.filtered({
            ...filter,
            teamId: undefined
          }));
        }
      }));
      mixpanel.track(`Member Teams Delete – Save`, {
        teamId: team.id
      });
    }
  };
  return /*#__PURE__*/React.createElement(Dropdown.List, {
    isOpen: isOpen,
    maxHeight: "500px",
    width: "420px",
    id: "member-team-scroll-target"
  }, /*#__PURE__*/React.createElement(MemberTeamForm, {
    setValue: setValue,
    watch: watch,
    control: control
  }), /*#__PURE__*/React.createElement(StickyBottomBox, {
    gap: 3,
    justify: "space-between",
    s: {
      p: 4
    },
    align: "center",
    fullWidth: true
  }, error && /*#__PURE__*/React.createElement(Alert, {
    severity: "danger",
    fullWidth: true
  }, error), /*#__PURE__*/React.createElement(Text, {
    color: "textSecondary",
    fontSize: 3.5,
    weight: "semiBold"
  }, watch("memberIds").length, " selected"), /*#__PURE__*/React.createElement(Box, {
    gap: 3,
    align: "center"
  }, /*#__PURE__*/React.createElement(Button, {
    color: "grey",
    s: {
      px: 6,
      py: 2
    },
    fontSize: 3.5,
    onClick: onItemClick
  }, t("common.actions.cancel")), !!team && /*#__PURE__*/React.createElement(Button, {
    onClick: handleDelete,
    color: "translucentDanger",
    s: {
      px: 6,
      py: 2
    },
    fontSize: 3.5
  }, t("common.actions.delete")), /*#__PURE__*/React.createElement(Button, {
    s: {
      px: 6,
      py: 2
    },
    fontSize: 3.5,
    color: "primary",
    loading: status === StatusStateEnum.LOADING,
    onClick: onSubmit
  }, t("common.actions.save")))));
};
export default MemberTeamsDropdown;